// extracted by mini-css-extract-plugin
export var hidden = "styles-module--hidden--ff350";
export var hidden__first = "styles-module--hidden__first--f824e";
export var info__label = "styles-module--info__label--7b67c";
export var notification = "styles-module--notification--b5c8c";
export var rating = "styles-module--rating--d70ce";
export var recomendations__line = "styles-module--recomendations__line--6a004";
export var recomendations__line__graph = "styles-module--recomendations__line__graph--2ce3b";
export var recomendations__line__titles = "styles-module--recomendations__line__titles--c5d83";
export var roundup = "styles-module--roundup--636fb";
export var row = "styles-module--row--0bd75";
export var section__res = "styles-module--section__res--3ab59";
export var section__text = "styles-module--section__text--508c3";
export var section__title = "styles-module--section__title--c8e3a";
export var single__product = "styles-module--single__product--e702f";
export var tooltip = "styles-module--tooltip--f61da";
export var tooltip__second = "styles-module--tooltip__second--abadb";
export var vibrations = "styles-module--vibrations--32df9";